import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface MagicLinkState {
    emailAddress: string | undefined;
}
interface MagicLinkStateStore extends MagicLinkState {
    setMagicLinkEmailAddress: (emailAddress: string) => void;
}

const initialState: MagicLinkState = {
    emailAddress: undefined,
};

export const useMagicLink = create<MagicLinkStateStore>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                setMagicLinkEmailAddress: (emailAddress) => set({ emailAddress }),
            }),
            { name: 'magic-link-storage' },
        ),
    ),
);
